import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostTaskCommentBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Posts a plain-text comment on a task and invalidates the task query cache. */
export function usePostTaskComment(taskId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: PostTaskCommentBody) => {
      const response = await api.post('/tasks/:taskId/comments', {
        params: { taskId },
        body: input,
      })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] })
      queryClient.invalidateQueries({ queryKey: ['patient-tasks'] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline'] })
      queryClient.invalidateQueries({ queryKey: ['my-tasks'] })
    },
  })
}
